type AnonymousLoggerMapper = {
  uuid: string;
  date: Date;
};

const storageKey = 'previousSubmissions';

export class FormSubmissionUtils {
  public static hasAnswered(uuid: string): boolean {
    const previousSubmissions = this.getSubmittedForms();
    return (
      previousSubmissions?.some((submission) => submission.uuid === uuid) ??
      false
    );
  }

  public static addNewAnsweredSurvey(uuid: string): void {
    const existing = this.getSubmittedForms();
    const newSubmittedForms: AnonymousLoggerMapper[] = [
      ...(existing || []),
      { uuid, date: new Date() },
    ];
    this.saveToStorage(newSubmittedForms);
  }

  private static saveToStorage(
    newSubmittedForms: AnonymousLoggerMapper[],
  ): void {
    try {
      window.localStorage.setItem(
        storageKey,
        JSON.stringify(newSubmittedForms),
      );
    } catch (error) {
      console.error('Error saving to localStorage:', error);
    }
  }

  private static getSubmittedForms(): AnonymousLoggerMapper[] | null {
    try {
      const forms = window.localStorage.getItem(storageKey);
      return forms ? (JSON.parse(forms) as AnonymousLoggerMapper[]) : null;
    } catch (error) {
      console.error('Error reading from localStorage:', error);
      return null;
    }
  }
}
